/**
 * Contact Form Controller
 * 必須チェック、メール一致確認、住所検索を統合
 */
class ContactForm {
  constructor() {
    this.form = document.getElementById("ContactForm");
    if (!this.form) return;

    // 要素の取得
    this.submitButton = document.getElementById("ContactForm-Submit");
    this.email = document.getElementById("ContactForm-email");
    this.emailConfirm = document.getElementById("ContactForm-email-confirm");
    this.emailErrorMsg = document.getElementById("ContactForm-email-confirm-error");

    this.zipInput = document.getElementById("ContactForm-zip");
    this.searchBtn = document.querySelector(".a_contact__btn-search");
    this.stateInput = document.getElementById("ContactForm-state");
    this.cityInput = document.getElementById("ContactForm-city");
    this.phoneInput = document.getElementById("ContactForm-phone");

    this.init();
  }

  init() {
    // 送信ボタンのバリデーション監視
    this.form.addEventListener("input", () => {
      this.cleanPhoneNumber(); // ボタンチェックの前に電話番号を常にクレンジング
      this.toggleSubmitButton();
    });
    this.form.addEventListener("change", () => {
      this.cleanPhoneNumber();
      this.toggleSubmitButton();
    });

    // メールアドレス一致チェック
    if (this.email && this.emailConfirm) {
      this.email.addEventListener("blur", () => this.validateEmail());
      this.emailConfirm.addEventListener("blur", () => this.validateEmail());
      this.emailConfirm.addEventListener("focus", () => this.clearEmailError());
    }

    // 電話番号のリアルタイムクレンジング監視
    if (this.phoneInput) {
      this.phoneInput.addEventListener("input", () => this.cleanPhoneNumber());
      this.phoneInput.addEventListener("blur", () => this.cleanPhoneNumber());
    }

    // 住所検索
    if (this.searchBtn) {
      this.searchBtn.addEventListener("click", () => this.fetchAddress());
    }

    // オートフィル対策：ブラウザの遅れてくる自動入力をキャッチするため、2秒間だけ定期チェックを回す
    let timerCount = 0;
    const autofillTimer = setInterval(() => {
      this.cleanPhoneNumber();
      this.toggleSubmitButton();
      timerCount++;
      if (timerCount > 10) clearInterval(autofillTimer); // 2秒経ったらタイマー停止
    }, 200);
  }

  /**
   * 電話番号の国際国番号（+81）を日本の「0」始まりにし、ハイフンもすべて自動除去
   */
  cleanPhoneNumber() {
    if (!this.phoneInput) return;
    
    let val = this.phoneInput.value.trim();
    
    // 半角ハイフン、全角ハイフン、長音、スペースをすべて跡形もなく消去
    val = val.replace(/[-ー－‐\s]/g, "");

    if (val.includes("+81")) {
      val = val.replace("+81", "").trim();
      if (val !== "" && !val.startsWith("0")) {
        val = "0" + val;
      }
    }
    
    // 画面上の入力値をハイフンなしの綺麗な数字のみに上書き
    if (this.phoneInput.value !== val) {
      this.phoneInput.value = val;
      this.toggleSubmitButton();
    }
  }

  /**
   * 送信ボタンの活性・非活性を切り替え
   */
  toggleSubmitButton() {
    if (!this.submitButton) return;

    const isFormValid = this.form.checkValidity();
    const isEmailMatching = this.email.value === this.emailConfirm.value;

    if (!isFormValid || !isEmailMatching) {
      console.clear();
      console.log("%c【デバッグ】送信ボタンが押せない原因一覧:", "color: #d00000; font-weight: bold; font-size: 14px;");
      
      Array.from(this.form.elements).forEach(el => {
        if (el.checkValidity && !el.checkValidity()) {
          console.log(`❌ 原因フィールド ➔ id: "${el.id}", name: "${el.name}" | 理由: ${el.validationMessage}`);
        }
      });
      
      if (!isEmailMatching) {
        console.log(`❌ 原因フィールド ➔ メールアドレスが一致していません。`);
      }
    } else {
      console.clear();
      console.log("%c✨ すべてのバリデーションを通過しました！ボタンを活性化します。", "color: #3ed660; font-weight: bold;");
    }

    // フォーム全体が有効 かつ メールが一致している場合のみ活性化
    this.submitButton.disabled = !(isFormValid && isEmailMatching);
  }

  /**
   * メールアドレスの一致確認
   */
  validateEmail() {
    if (this.email.value && this.emailConfirm.value) {
      if (this.email.value !== this.emailConfirm.value) {
        this.emailErrorMsg.style.display = "block";
        this.emailConfirm.classList.add("a_field__input--error");
      } else {
        this.clearEmailError();
      }
      this.toggleSubmitButton();
    }
  }

  clearEmailError() {
    this.emailErrorMsg.style.display = "none";
    this.emailConfirm.classList.remove("a_field__input--error");
  }

  /**
   * 郵便番号から住所を取得
   */
  fetchAddress() {
    const zip = this.zipInput.value.replace("-", "");

    if (zip.length !== 7) {
      alert("郵便番号は7桁で入力してください。");
      return;
    }

    fetch(`https://zipcloud.ibsnet.co.jp/api/search?zipcode=${zip}`)
      .then((response) => response.json())
      .then((data) => {
        if (data.results) {
          const result = data.results[0];
          this.stateInput.value = result.address1;
          this.cityInput.value = result.address2 + result.address3;
          this.cityInput.focus();
          this.toggleSubmitButton();
        } else {
          alert("該当する住所が見つかりませんでした。");
        }
      })
      .catch((error) => {
        console.error("Error:", error);
        alert("住所の取得に失敗しました。");
      });
  }
}

// 実行
document.addEventListener("DOMContentLoaded", () => {
  new ContactForm();
});